/* eslint-disable no-throw-literal */
import {
  GET_EVALUATE_ANSWER_EXIST,
  GET_EVALUATE_ANSWER_CALL_EXIST,
  EVALUATE_ANSWER_NOANSWER_LIST,
  EVALUATE_ANSWER_ANSWER_DETAIL_LIST,
  EVALUATE_ANSWER_ANSWER_UPDATE,
  EVALUATE_ANSWER_ALL_ANSWER_UPDATE
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_EVALUATE_ANSWER_EXIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/evaluate_answers/exist', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_EVALUATE_ANSWER_CALL_EXIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/evaluate_answers/call_exist', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [EVALUATE_ANSWER_NOANSWER_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/evaluate_answers/noanswer_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [EVALUATE_ANSWER_ANSWER_DETAIL_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/evaluate_answers/answer_detail_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [EVALUATE_ANSWER_ANSWER_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/evaluate_answers/save_answers', id: params.id, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [EVALUATE_ANSWER_ALL_ANSWER_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/evaluate_answers/save_answer_flag', data: {id: params.id} })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/evaluate-answer.js